import { useQuery } from '@tanstack/react-query';
import { IconLocalMappings } from '@blisspointmedia/bpm-types/dist/LinearBuying';
import { awaitJSON, LinearBuyingLambdaFetch } from '@src/utils/fetch-utils';

export const useIconLocalMappings = (): ReturnType<typeof useQuery<IconLocalMappings>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['iconLocalMappings'],
    queryFn: async (): Promise<IconLocalMappings> =>
      awaitJSON<IconLocalMappings>(await LinearBuyingLambdaFetch('/icon_local_mappings'))
  });

export const saveIconLocalMappings = async (updated: IconLocalMappings): Promise<void> => {
  await LinearBuyingLambdaFetch('/icon_local_mappings', {
    method: 'POST',
    body: updated
  });
};
